mutation RecordPrices($prices: [PriceInput!]!) {
    recordPrices(prices: $prices) {
        id
        productID
        value
        basicUnitOfMeasurement
        calculationUnitOfMeasurement
        unitOfIssue
        quantityPerIssue
        roundToPiece
        roundToPackage
        roundToPalette
        disablePackageRounding
        vat
        valid { from to }
        type
    }
}
